// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api',
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
};

// Application Constants
export const APP_CONFIG = {
  APP_NAME: 'Poultry Management System',
  VERSION: '1.0.0',
  COMPANY: 'Laksha Enterprises',
};

// Payment Status Constants
export const PAYMENT_STATUS = {
  PAID: 'PAID',
  PARTIAL: 'PARTIAL',
  PENDING: 'PENDING',
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'ADMIN',
  ACCOUNTANT: 'ACCOUNTANT',
  STAFF: 'STAFF',
};

// Expense Categories
export const EXPENSE_CATEGORIES = {
  FUEL: 'FUEL',
  MAINTENANCE: 'MAINTENANCE',
  FEED: 'FEED',
  LABOUR: 'LABOUR',
  MISCELLANEOUS: 'MISCELLANEOUS',
};

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'DD/MM/YYYY',
  API: 'YYYY-MM-DD',
  DATETIME: 'DD/MM/YYYY HH:mm',
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
  THEME: 'theme_preference',
};
